import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { FilterControl } from '../../../interfaces/filter-control';
import { FilterControlParams } from '../../../interfaces/filter-control-params';
import { BmCache } from '../../../../data-access/services/bm-cache.service';

@Component({
  selector: 'bm-enum-filter',
  templateUrl: './enum-filter.component.html',
  styleUrls: ['./enum-filter.component.scss']
})
export class EnumFilterComponent implements FilterControl, OnInit {


  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;



  options: any[] = [];

  constructor(private cache: BmCache) {}


  async ngOnInit() {

    this.options = await this.cache.loadEnums(this.control.params.optionsKeyword);

    if (this.control.compactValue) {

      const ids = this.control.compactValue.split(',').map(id => +id);
      this.control.value = this.options.filter(option => {
        const idKey = Object.keys(option).find(key => key.startsWith('_'));
        return ids.includes(option[idKey]);
      });

    }
  }

}
